import React from "react";

export const Logo = ({ variant = "dark", className = "h-14" }) => (
  <img
    data-testid={`logo-${variant}`}
    src={variant === "dark" ? "/logo.png" : "/logo-white.png"}
    alt="HTS Janzen Hausverwaltung"
    className={`${className} w-auto object-contain`}
  />
);

export const LogoHorizontal = () => (
  <div className="flex items-center gap-3" data-testid="logo-horizontal">
    <img src="/logo-icon.png" alt="" className="h-12 w-auto object-contain" />
    <div className="leading-none">
      <div className="font-display font-bold tracking-[0.18em] text-[17px] text-[#1b3a63]">
        HTS JANZEN
      </div>
      <div className="mt-1 pt-1 border-t border-[#1b3a63]/70 text-[9px] tracking-[0.32em] uppercase text-[#1b3a63]">
        Hausverwaltung
      </div>
    </div>
  </div>
);
